import { createGlobalStyle } from 'styled-components';

/** @font-face lives in public/fonts/pretendard/pretendard.css (HTML head preload) */
export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: Pretendard, 'Pretendard Fallback', -apple-system, BlinkMacSystemFont, system-ui, "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
    margin: 0;
    padding: 0;
  }
    
  body {
    width: 100vw;
    height: 100vh;
    margin: 0px;
  }

  h1, h2, p {
    margin: 0px;
  }

  button {
    appearance: none;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 0px;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
